import { useCallback } from 'react';
import { Button } from 'react-bootstrap';
import isBrowser from 'utils/is-browser';

export default function ZendeskChatButton({
  containerCss,
  title,
  zendeskChatUrl,
}) {
  const loadAndOpenZendeskChat = useCallback(() => {
    if (isBrowser && zendeskChatUrl) {
      const script = document.createElement('script');
      script.id = 'ze-snippet';
      script.async = true;
      script.src = zendeskChatUrl;
      script.addEventListener('load', () => {
        /* eslint-disable no-undef */
        if (zE) {
          zE('messenger:set', 'zIndex', 1050);
          zE('messenger', 'open');
        }
        /* eslint-enable no-undef */
      });
      document.head.append(script);
    }
  }, [zendeskChatUrl]);

  const handleClick = useCallback(() => {
    /* eslint-disable no-undef */
    if (typeof zE === 'function') {
      zE('messenger', 'open');
    } else {
      loadAndOpenZendeskChat();
    }
    /* eslint-enable no-undef */
  }, [loadAndOpenZendeskChat]);

  return (
    zendeskChatUrl &&
    title && (
      <div className={containerCss}>
        <Button
          type="button"
          title="Chat with customer service"
          className="fs-7 align-top"
          variant="secondary"
          onClick={handleClick}
        >
          {title}
        </Button>
      </div>
    )
  );
}
